export default "__VITE_ASSET__BcwY566T__"